<template>
  <div>
    <span v-translate>{{ label }}</span>
    <status-component
      :level="value.level"
      :display="value.display">
    </status-component>
  </div>
</template>
<script>
  import StatusComponent from '@/components/layout/utility/StatusComponent'
  export default {
    name: 'status-cell-component',
    components: {
      StatusComponent
    },
    props: {
      label: {
        type: String,
        required: true
      },
      value: {
        type: Object,
        required: true
      }
    }
  }

</script>
